export default __webpack_public_path__ + "static/media/IMG_0465 copie.054d278c.jpg";